import React from 'react';

import './SpinnerComponent.scss';

export const SpinnerComponent = () => (
  <div className="loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/SpinnerComponent.js